module.exports = __webpack_public_path__ + "static/12-Business-Centre-Overlooking-Pool-3166918dae700c15cb2c8d9ec60c9325.jpg";